import { AuthService } from './../user/auth.service';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { CustomerCardModel } from '../../models/customer-card.model';
import { SubstituteCardModel } from '../../models/substitute-card.model';
import { CustomerCardListModel } from '../../models/customer-cards.model';
import { BalanceModel } from '../../models/balance.model';
import { ApiAddCardModel } from '../../models/api-add-card.model';
import { ApiBlacklistCardModel } from '../../models/api-blacklist-card.model';
import { CustomerExt } from '../../models/customer-ext.model';
import * as moment from 'moment';

@Injectable()
export class CustomerCardService {

  public baseUrlApi =   '/koncentro-api';
  public baseUrlLoyalty = '/koncentro-loyalty';
  public baseUrlCustomer = '/koncentro-customers/v2/customers';
  public baseUrlVCustomer = '/koncentro-customers/v2/vcustomers';
  public baseUrlCustomerCard = '/koncentro-customers/card';

  companyCode: number;


  constructor (
    private http: HttpClientService,
    private authService: AuthService
  ) {
    this.companyCode = authService.user.selectedCompany;
  }

  getAvailableCards(cardNoFilter: string, channel_id?: any): Observable<CustomerCardListModel[]> {
    return this.http.get(this.baseUrlLoyalty + '/cards/getAvailableCards' + (cardNoFilter ? '?cardNo=' + cardNoFilter : '') + (channel_id ? '&channel_id=' + channel_id : '')).map(res => {
      return res;
    });
  }

  linkCard(customerId: number, cardId: number) {
    return this.http.post(`${this.baseUrlCustomerCard}/linkCard`, {customer_id: customerId, card_id: cardId});
  }

  unlinkCard(customerId: number, cardId: number) {
    return this.http.post(`${this.baseUrlCustomerCard}/unlinkCard?cardId=${cardId}&customerId=${customerId}`, {});
  }

  // [P
  addCard(card: ApiAddCardModel): Observable<any> {
    return this.http.put(this.baseUrlApi + '/internal/addCard', card).map(res => {
      return res;
    });
  }



  createCardLink(cardId: string): Observable<any> {
    return this.http.post(this.baseUrlVCustomer + /createCardLink/ + cardId, null).map(res => {
      return res;
    });
  }

  /*
    blacklistCard(cardId: number, blacklistModel: BlacklistCardModel): Observable<any> {
      return this.http.put(this.baseUrlLoyalty + '/card/' + cardId + '/setBlackList', blacklistModel).map(res => {
        return res;
      });
    }
  */

  blacklistCard(cardId: number, blacklistModel): Observable<any> {
    return this.http.put(this.baseUrlApi + '/internal/cards/' + cardId + '/blacklistCard', blacklistModel).map(res => {
      return res;
    });
  }

  substituteCard(substituteModel: SubstituteCardModel): Observable<any> {
    return this.http.put(this.baseUrlApi + '/internal/substituteCard', substituteModel).map(res => {
      return res;
    });
  }

  substituteCardAdvanced(substituteModel: SubstituteCardModel): Observable<any> {
    return this.http.put(this.baseUrlApi + '/internal/substituteCardAdvanced', substituteModel);
  }
  substituteCardAdvanced_success(substituteModel: SubstituteCardModel): Observable<any> {
    return this.http.putSuccess(this.baseUrlApi + '/internal/substituteCardAdvanced', substituteModel);
  }

  createCustomerExt(model: CustomerExt): Observable<any> {
    // fixme: sarebbe da spostare nel CustomerService
    if ( model.birthDate == null) {
      delete model.birthDate;
    } else {
      model.birthDate = moment(model.birthDate).format('YYYY-MM-DD');
    }
    return this.http.post(this.baseUrlApi + '/custom/createCustomerExt', model).map(res => {
      return res;
    });
  }

  createCustomerStore(model: CustomerExt): Observable<any> {
    // fixme: sarebbe da spostare nel CustomerService
    model.birthDate = moment(model.birthDate).format('YYYY-MM-DD');
    return this.http.post(this.baseUrlApi + '/custom/createCustomerStore', model).map(res => {
      return res;
    });
  }
  getBalances(vCustomerId: number, cards: CustomerCardListModel[]): Observable<BalanceModel[]> {

    let cardNotAvaiable: boolean = true;
    cards.forEach(card =>{
      if( !( card.flagBlackList =='1' || card.cardLinkStatus == '7'
             || card.flg_state == '1'  || card.flg_state == 'D')
        ){
        cardNotAvaiable = false;
        return;
      }
    });

    if(!cardNotAvaiable){
      let cardNo = cards.map(c => c.cardNo);
      let params = {
        'vCustomerId': vCustomerId
      };

      if (cardNo.length > 0) {
        params['cardNo'] = cardNo.join(',');
      }

      return this.http.get(this.baseUrlApi + '/internal/getFullBalances', params).map(res => {
        return res;
      });
    }
  }

  /**
   * Viene richiamata quando l'utente non ha il permesso di visualizzare i clienti associati alle carte.
   * Verifica che vi sia corrispondenza tra il numero della carta da sostituire ed i dati utente inseriti.
   * @param cardNo
   * @param surname
   * @param name
   * @param birthDate
   */
  getCustomerByCardNo(cardNo: string, surname: string, name?: string, birthDate?: string) {
    return this.http.get(`${this.baseUrlApi}/internal/getCustomerByCardNo?cardNo=${cardNo}&nome=${name}&cognome=${surname}&dataNascita=${birthDate}`);
  }

  /**
   * Restituisce la lista delle carte figlie di una carta Kloy selezionata da Scheda Cliente
   * @param cardNumber
   * @returns
   */
  getKloyChildCards(cardNumber: string) {
    return this.http.get(`koncentro-api/kloy/readFamilyCards?companyCode=${this.companyCode}&cardNo=${cardNumber}`);
  }

  /**
   * Collega due carte Kloy
   * @param parentCardNumber
   * @param childCardNumber
   */
  linkKloyCard(parentCardNumber: string, childCardNumber: string) {
    const data = {parentCardNo: parentCardNumber, cardNo: childCardNumber};
    return this.http.post(`koncentro-api/kloy/linkFamilyCard?companyCode=${this.companyCode}`, data);
  }

  /**
   * Scollega due carte Kloy
   * @param parentCardNumber
   * @param childCardNumber
   */
   unlinkKloyCard(parentCardNumber: string, childCardNumber: string) {
    const data = {parentCardNo: parentCardNumber, cardNo: childCardNumber};
    return this.http.post(`koncentro-api/kloy/unlinkFamilyCard?companyCode=${this.companyCode}`, data);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/customer/customer-card.service.ts